import { PrivacyLevel, TimelineEntry, TimelineSection, User } from "@/types";

export const CURRENT_USER: User = {
  id: "1",
  username: "maxmustermann",
  name: "Max Mustermann",
  email: "max.mustermann@example.com",
  birthdate: "1995-01-26",
  profilePicture: "" // Removed profile picture
};

export const DEFAULT_TIMELINE_SECTIONS: TimelineSection[] = [
  {
    id: "1",
    name: "Embryonale Phase",
    name_en: "Embryonic Phase",
    slug: "embryonic",
    age_from: -1,
    age_to: 0,
    description: "Die pränatale Entwicklung, Beginn allen Seins.",
    description_en: "Prenatal development, the beginning of all existence.",
    icon: "✨",
    cosmic_aspect: "Der Ursprung, Verbindung zu Schöpfung und Wasser",
    cosmic_aspect_en: "The origin, connection to creation and water",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 1994,
    yearTo: 1995,
    isExpanded: true
  },
  {
    id: "2",
    name: "Kindheit",
    name_en: "Childhood",
    slug: "childhood",
    age_from: 0,
    age_to: 11,
    description: "Wachstum und spielerische Entfaltung.",
    description_en: "Growth and playful development.",
    icon: "🪴",
    cosmic_aspect: "Mond: Emotionale Sicherheit, Entwicklung",
    cosmic_aspect_en: "Moon: Emotional security, development",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 1995,
    yearTo: 2006,
    isExpanded: true
  },
  {
    id: "3",
    name: "Jugend",
    name_en: "Adolescence",
    slug: "adolescence",
    age_from: 12,
    age_to: 20,
    description: "Pubertät, Identitätsfindung und soziale Bindungen.",
    description_en: "Puberty, identity formation and social bonds.",
    icon: "✨",
    cosmic_aspect: "Venus und Mars: Liebe und Energie",
    cosmic_aspect_en: "Venus and Mars: Love and energy",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2007,
    yearTo: 2015,
    isExpanded: false
  },
  {
    id: "4",
    name: "Frühes Erwachsenenalter",
    name_en: "Early Adulthood",
    slug: "early_adulthood",
    age_from: 21,
    age_to: 29,
    description: "Aufbruch und erste größere Lebensentscheidungen.",
    description_en: "New beginnings and first major life decisions.",
    icon: "🏔️",
    cosmic_aspect: "Jupiter: Expansion, Aufbruch",
    cosmic_aspect_en: "Jupiter: Expansion, departure",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2016,
    yearTo: 2024,
    isExpanded: false
  },
  {
    id: "5",
    name: "Reifephase",
    name_en: "Mature Phase",
    slug: "mature_phase",
    age_from: 30,
    age_to: 39,
    description: "Persönliche und berufliche Stabilisierung.",
    description_en: "Personal and professional stabilization.",
    icon: "🌳",
    cosmic_aspect: "Saturn: Reife, Verantwortung",
    cosmic_aspect_en: "Saturn: Maturity, responsibility",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2025,
    yearTo: 2034,
    isExpanded: false
  },
  {
    id: "6",
    name: "Lebensmitte",
    name_en: "Midlife",
    slug: "midlife",
    age_from: 40,
    age_to: 49,
    description: "Reflexion und Balance zwischen Lebenszielen.",
    description_en: "Reflection and balance between life goals.",
    icon: "⚖️",
    cosmic_aspect: "Uranus: Veränderung, Freiheit",
    cosmic_aspect_en: "Uranus: Change, freedom",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2035,
    yearTo: 2044,
    isExpanded: false
  },
  {
    id: "7",
    name: "Reifejahre",
    name_en: "Years of Maturity",
    slug: "years_of_maturity",
    age_from: 50,
    age_to: 64,
    description: "Selbstverwirklichung und neue Prioritäten.",
    description_en: "Self-realization and new priorities.",
    icon: "🦋",
    cosmic_aspect: "Neptun: Intuition, Spiritualität",
    cosmic_aspect_en: "Neptune: Intuition, spirituality",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2045,
    yearTo: 2059,
    isExpanded: false
  },
  {
    id: "8",
    name: "Älteres Erwachsenenalter",
    name_en: "Later Adulthood",
    slug: "later_adulthood",
    age_from: 65,
    age_to: 99,
    description: "Gelassenheit, Weisheit und Rückblick.",
    description_en: "Serenity, wisdom and reflection.",
    icon: "🌅",
    cosmic_aspect: "Pluto: Loslassen, Erneuerung",
    cosmic_aspect_en: "Pluto: Letting go, renewal",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    yearFrom: 2060,
    yearTo: 2094,
    isExpanded: false
  }
];

export const MOCK_ENTRIES: TimelineEntry[] = [
  {
    id: "1",
    user_id: "1",
    profile_timeline_section_id: "2",
    creator_id: "2",
    title: "Sommerfest im Garten",
    content: "Ein wunderschöner Sommertag mit leckerem Picknick im Garten. Die Familie hat sich zum gemeinsamen Essen versammelt.",
    date: "1998-07-20",
    year: 1998,
    month: 7,
    day: 20,
    photos: [
      "/Bildschirmfoto 2025-06-22 um 19.52.50.png",
      "/Bildschirmfoto 2025-06-22 um 19.52.59.png"
    ],
    privacy_level: PrivacyLevel.FRIENDS,
    is_approved: true,
    created_at: "2023-01-01T12:00:00Z",
    updated_at: "2023-01-01T12:00:00Z"
  },
  {
    id: "2",
    user_id: "1",
    profile_timeline_section_id: "2",
    creator_id: "2",
    title: "Erste Einschulung",
    content: "Ein wichtiger Tag im Leben. Die erste Einschulung mit den besten Freunden.",
    date: "1995-08-15",
    year: 1995,
    month: 8,
    day: 15,
    photos: [
      "/Bildschirmfoto 2025-06-22 um 19.53.03.png"
    ],
    privacy_level: PrivacyLevel.FRIENDS,
    is_approved: true,
    created_at: "2023-01-01T12:00:00Z",
    updated_at: "2023-01-01T12:00:00Z"
  },
  {
    id: "3",
    user_id: "1",
    profile_timeline_section_id: "2",
    creator_id: "3",
    title: "Tolle Zeit mit Freunden",
    content: "Unvergessliche Momente mit den besten Freunden. Gemeinsam lachen und Spaß haben.",
    date: "2000-05-12",
    year: 2000,
    month: 5,
    day: 12,
    photos: [
      "/Bildschirmfoto 2025-06-22 um 19.53.10.png",
      "/Bildschirmfoto 2025-06-22 um 19.53.15.png"
    ],
    privacy_level: PrivacyLevel.FRIENDS,
    is_approved: true,
    created_at: "2023-02-15T14:30:00Z",
    updated_at: "2023-02-15T14:30:00Z"
  },
  {
    id: "4",
    user_id: "1",
    profile_timeline_section_id: "3",
    creator_id: "2",
    title: "Beste Freunde fürs Leben",
    content: "Ein perfekter Tag mit der Clique. Diese Freundschaften werden für immer halten.",
    date: "2010-09-18",
    year: 2010,
    month: 9,
    day: 18,
    photos: [
      "/Bildschirmfoto 2025-06-22 um 19.52.50.png"
    ],
    privacy_level: PrivacyLevel.PUBLIC,
    is_approved: true,
    created_at: "2023-03-22T09:15:00Z",
    updated_at: "2023-03-22T09:15:00Z"
  },
  {
    id: "5",
    user_id: "1",
    profile_timeline_section_id: "4",
    creator_id: "1",
    title: "Unvergesslicher Männertag",
    content: "Ein epischer Tag mit den Jungs bei Sonnenuntergang. Diese Momente vergisst man nie.",
    date: "2018-06-03",
    year: 2018,
    month: 6,
    day: 3,
    photos: [
      "/Bildschirmfoto 2025-06-22 um 19.53.15.png"
    ],
    privacy_level: PrivacyLevel.FRIENDS,
    is_approved: true,
    created_at: "2023-04-10T16:20:00Z",
    updated_at: "2023-04-10T16:20:00Z"
  }
];
